import React, { lazy } from 'react';
import { Route } from 'react-router-dom';
import { ProtectedRoute } from '@/components/ProtectedRoute';

const RestaurantMenuPage = lazy(() => import("@/features/customer/pages/RestaurantMenu"));
const Checkout = lazy(() => import("@/features/customer/pages/Checkout"));
const OrderStatus = lazy(() => import("@/features/customer/pages/OrderStatus"));
const OrderHistory = lazy(() => import("@/features/customer/pages/OrderHistory"));
const ReviewOrder = lazy(() => import("@/features/customer/pages/ReviewOrder"));
const Profile = lazy(() => import("@/features/customer/pages/Profile"));

export const customerRoutes = (
  <>
    <Route path="/restaurant/:id" element={
      <ProtectedRoute allowedRoles={['customer']}>
        <RestaurantMenuPage />
      </ProtectedRoute>
    } />
    <Route path="/checkout" element={
      <ProtectedRoute allowedRoles={['customer']}>
        <Checkout />
      </ProtectedRoute>
    } />
    <Route path="/order-status/:orderId" element={
      <ProtectedRoute allowedRoles={['customer']}>
        <OrderStatus />
      </ProtectedRoute>
    } />
    <Route path="/order-history" element={
      <ProtectedRoute allowedRoles={['customer']}>
        <OrderHistory />
      </ProtectedRoute>
    } />
    {/* /order/:orderId redirects to order-status */}
    <Route path="/order/:orderId" element={
      <ProtectedRoute allowedRoles={['customer']}>
        <OrderStatus />
      </ProtectedRoute>
    } />
    <Route path="/review-order/:orderId" element={
      <ProtectedRoute allowedRoles={['customer']}>
        <ReviewOrder />
      </ProtectedRoute>
    } />
    <Route path="/order/:orderId/review" element={
      <ProtectedRoute allowedRoles={['customer']}>
        <ReviewOrder />
      </ProtectedRoute>
    } />
    <Route path="/profile" element={
      <ProtectedRoute allowedRoles={['customer', 'restaurant_owner', 'admin']}>
        <Profile />
      </ProtectedRoute>
    } />
  </>
);
